/* unplugin-vue-components disabled */import script from "./reserve_Cup.vue?vue&type=script&setup=true&lang=ts"
export * from "./reserve_Cup.vue?vue&type=script&setup=true&lang=ts"

import "./reserve_Cup.vue?vue&type=style&index=0&id=79879018&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79879018"]])

export default __exports__